class ReadMoreToggle extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.read-more-btn');
    this.content = this.querySelector('.read-more-content');
    this.isExpanded = false;
  }

  connectedCallback() {
    if (this.button && this.content) {
      this.button.addEventListener('click', this.toggle.bind(this));
    }
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
    this.content.classList.toggle('expanded', this.isExpanded);
    this.button.textContent = this.isExpanded 
      ? this.button.dataset.lessText 
      : this.button.dataset.moreText;
    this.button.setAttribute('aria-expanded', this.isExpanded);
  }
}

customElements.define('read-more-toggle', ReadMoreToggle);
